import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { ContactSelect } from '../../../../../../../../components/ApiField';
import { Link } from '@material-ui/core';
import ContactForm from './ContactForm';

interface Props {
  siteId: string;
  className: string;
  newContactFormEnabled: boolean;
  onSwitchNewContactForm: (enabled: boolean) => void;
  control: Control<any>;
}

const ContactField: FC<Props> = ({ newContactFormEnabled, onSwitchNewContactForm, control, siteId, className }) => {
  return !newContactFormEnabled ? (
    <>
      <Controller
        name='associatedContactId'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <ContactSelect {...field} siteId={siteId} error={undefined !== error} helperText={error?.message} required />
        )}
      />

      <Link
        className={className}
        onClick={() => onSwitchNewContactForm(true)}
        component='button'
        type='button'
        variant='caption'
        color='primary'
      >
        + Créer un nouveau contact
      </Link>
    </>
  ) : (
    <ContactForm className={className} onClose={() => onSwitchNewContactForm(false)} control={control} />
  );
};

export default ContactField;
